import styled from "styled-components";

const FullWidthListContainer = styled.ul`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
  padding: 0;
  margin: 0;
`;

export default FullWidthListContainer;
